import React from 'react';
import { linkTo } from '@prisjakt/ui-app-context';
import { ScrollElement } from '@prisjakt/ui-scroll';
import PreReleaseInformation from '../../../pre-release-information';
import PriceHistory from '../../../price-history';
import PriceList from '../../../price-list';
import ReadableProductInformation from '../../../readable-product-information';
import Recommendations from '../../../../../../components/recommendations';
import { PRODUCT_CONTEXT_ID } from '../../../../constants';
import { Maybe, Product } from '../../../../../../types';
import { CurrentCampaign } from '../../../../types';
import {
  ModelType,
  ModelTypeEnum,
} from '../../../../../../components/recommendations/types';
import { CoreProperties } from '../../../readable-product-information/types';

const ProductTabMain: React.FC<IProductTabMainProps> = props => {
  const {
    isPreRelease,
    product,
    similarProducts,
    getRecommendationsLink,
    currentCampaign,
  } = props;

  return (
    <>
      {isPreRelease && product.releaseDate && (
        <PreReleaseInformation
          product={product}
          releaseDate={product.releaseDate}
        />
      )}
      {product.statistics &&
        product.statistics.pageInfo &&
        product.statistics.pageInfo.lowestPrice &&
        isPreRelease && (
          <PriceHistory
            route={linkTo('productPriceHistory', product)}
            productName={product.name}
            statistics={product.statistics}
          />
        )}
      {isPreRelease && similarProducts?.recommendations?.length ? (
        <Recommendations
          link={getRecommendationsLink(ModelTypeEnum.SIMILAR_PRODUCTS)}
          recommendations={similarProducts.recommendations}
          type={ModelTypeEnum.SIMILAR_PRODUCTS}
          contextId={PRODUCT_CONTEXT_ID}
        />
      ) : null}
      {product.prices && (
        <ScrollElement name="Pricelist" data-test="MainTabContent">
          <PriceList
            productId={product.id}
            category={product.category}
            media={product.media}
            brand={product.brand}
            prices={product.prices}
            conditions={product.conditions}
            adOffset={1}
            campaign={currentCampaign as CurrentCampaign}
            variantGroups={product.variantGroups}
          />
        </ScrollElement>
      )}

      <ReadableProductInformation product={product} />
    </>
  );
};

interface IProductTabMainProps {
  isPreRelease: boolean | '' | null;
  product: Product & Maybe<{ coreProperties: CoreProperties }>;
  similarProducts: any;
  getRecommendationsLink: (
    modelType: ModelType
  ) =>
    | {
        title: string;
        url: string;
        onClick: () => void | null;
      }
    | {
        title: string;
        url: string;
        onClick?: undefined;
      }
    | null;
  currentCampaign: any;
}

export default ProductTabMain;
